import { Rectangle } from "./rectangle";

export class ImageChunk {
  private readonly _url: string;
  private readonly _srcRect: Rectangle;
  private readonly _dstRect: Rectangle;

  public toString(): string {
    return `{url:${this.url},src:s${this.srcRect},dst:${this.dstRect}`;
  }

  constructor(url: string, src: Rectangle, dst: Rectangle) {
    this._url = url;
    this._srcRect = src;
    this._dstRect = dst;
  }

  public get url(): string {
    return this._url;
  }

  public get srcRect(): Rectangle {
    return this._srcRect;
  }

  public get dstRect(): Rectangle {
    return this._dstRect;
  }
}
